import { RoutesV1 } from "constants/appRoutes"
import { LINK_DEV } from "constants/index"
// import {}
const urls = [
  {
    title: 'Menu',
    items: [
      {
        url: `${LINK_DEV}/pages/premium-payment'`,
        icon: 'sli-chart',
        title: 'Thanh toán phí bảo hiểm',
        items: []
      },
      {
        url: LINK_DEV,
        icon: 'sli-action-redo',
        title: 'Truy vấn hợp đồng',
        items: [
          {
            url: `${LINK_DEV}/pages/contract-query`,
            icon: '',
            title: 'Hợp đồng cá nhân',
            items: []
          },
          {
            url: RoutesV1.groupProduct,
            icon: '',
            title: 'Hợp đồng nhóm',
            items: []
          }
				]
			},
      {
        url: LINK_DEV,
        icon: 'sli-action-redo',
        title: 'Quản trị viên',
        items: [
          {
            url: '/pages/cat-param-config',
            icon: '',
            title: 'Danh mục tham số HT',
            items: []
          }
				]
			},
      {
        url: LINK_DEV,
        icon: 'sli-action-redo',
        title: 'Quản lý tài khoản',
        items: [
          {
            url: `${LINK_DEV}/pages/cat-param-config`,
            icon: '',
            title: 'Quản lý thông tin tài khoản',
            items: []
          }
				]
			}
    ]
  }
]
export function menus(state = Array.from(urls), action) {
  switch (action.type) {
    case 'SET_MENU':
      return Object.assign({}, state, {
        ...action.menu
      })
    default:
      return state
  }
}
